module.exports = __webpack_public_path__ + "static/icon/tripwise-icon-fill/iconfont.woff";